import moment from 'moment/moment'
import * as types from './mutations-types'

const mutations = {
  [types.GET_INFO] (state, info) {
    state.personInfo = info
  },
  [types.CHANGE_INTENTION] (state, intention) {
    state.intention = intention
  },
  [types.CHANGE_CITY] (state, cities) {
    state.cities = cities
  },
  [types.CHANGE_CURRENT_INDEX] (state, index) {
    state.currentIndex = index
  },
  [types.IS_MEMBERSHIP] (state, isMembership) {
    state.isMembership = isMembership
  },
  [types.GET_MEMBERSHIP] (state, membership) {
    state.membership = membership
  },
  [types.GET_BUY_MEMBER_DATA] (state, buyMemeberData) {
    state.buyMemeberData = buyMemeberData
  },
  [types.GET_UDESK_ONLINE_URL] (state, udeskOnlineUrl) {
    state.udeskOnlineUrl = udeskOnlineUrl
  },
  [types.PUBLIC_KEY] (state, publicKey) {
    state.publicKey = publicKey
  },
  [types.PRIVATE_KEY] (state, privateKey) {
    state.privateKey = privateKey
  },
  [types.USER_TOKEN] (state, userToken) {
    state.userToken = userToken
  },
  [types.IS_LOGIN](state, data) {
    state.isLogin = data
  },
  [types.GET_USER_IDENTIFY](state, data) {
    state.userIdentify = data
  },
  [types.SET_PURCHASE_RECORD_DATA](state, data) {
    const DATA_FORMAT = 'YYYY-MM-DD HH:mm:ss'
    const { time_now, order_time } = data
    if (time_now) {
      data.time_now = moment(time_now).format(DATA_FORMAT)
    }
    
    if (order_time) {
      data.order_time = moment(order_time).format(DATA_FORMAT)
    }
    
    state.purchaseRecordData = data;
  },
  IS_USER(state, data) {
      state.isUser = data
  },
  SET_PERSON_MENU(state, data) {
    state.personMenu = data
  },
  SET_GET_CURRENT_USER(state, data) {
    state.isGetCurrentUser = data
  },
  [types.SET_COUNTDOWN_STATE](state, data) {
    state.countdownState = data
  }
}

export default mutations
